import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Neaz Morshed </span>
            from <span className="purple"> Dhaka, Bangladesh.</span>
            <br />I am a passionate software engineer as well as quick learner. I like to solve real world problem in real world application. I always try to do something innovative in the field of software engineering. Like to write software which are clean, optimize and give professional touch. I want to share my experience and Skills with the organization and help to build strong team. I always focus on quality code and eager to learn new technologies.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Long way to go befor I sleep."{" "}
          </p>
          <footer className="blockquote-footer">Robert Kennedy</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
